// Pages that render without the site's header, footer, banners, Crisp or
// Cello. TP-389's app mode hides the same chrome, so it can share this:
// hideSiteChrome = isNativeApp || isChromelessPath.
const CHROMELESS_PATHS = ['/whats-new/preview'];

export const isChromelessPath = (pathname) =>
  !!pathname && CHROMELESS_PATHS.some((path) => pathname.indexOf(path) === 0);

export default isChromelessPath;
